import React from 'react';
import {
  Modal,
  ModalBody, ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

function SettingsModal({ isOpen, onClose, title, children, size }) {
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      size={size}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="10px 10px 7px 7px"
        height="auto"
      >
        <ModalCloseButton _focus={{ bg: 'white', color: 'primaryScale.600' }} color="white" />
        <ModalHeader
          bg="primaryScale.600"
          borderRadius="10px 10px 0px 0px"
          color="white"
          fontSize="lg"
          textAlign="center"
        >
          {title}
        </ModalHeader>
        <ModalBody p={0}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

SettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node])
};

export default SettingsModal;
